import { p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
import { a as addCommasForCompositeRanges } from "./composites-AoyAbg6U.js";
const cell = React__default.memo(function Cell(props) {
  let { id, SVs, children } = useDoenetRenderer(props);
  if (SVs.hidden) {
    return null;
  }
  let properties = {
    style: { padding: "3px 10px" }
  };
  if (SVs.colSpan !== 1) {
    properties.colSpan = SVs.colSpan;
  }
  if (SVs.halign !== null) {
    properties.style.textAlign = SVs.halign;
  }
  if (SVs.bottomBorder !== "none") {
    properties.style.borderBottomStyle = "solid";
    if (SVs.bottomBorder === "minor") {
      properties.style.borderBottomWidth = "thin";
    } else if (SVs.bottomBorder === "medium") {
      properties.style.borderBottomWidth = "medium";
    } else {
      properties.style.borderBottomWidth = "thick";
    }
  }
  if (SVs.endBorder !== "none") {
    properties.style.borderInlineEndStyle = "solid";
    if (SVs.endBorder === "minor") {
      properties.style.borderInlineEndWidth = "thin";
    } else if (SVs.endBorder === "medium") {
      properties.style.borderInlineEndWidth = "medium";
    } else {
      properties.style.borderInlineEndWidth = "thick";
    }
  }
  if (SVs._compositeReplacementActiveRange) {
    children = addCommasForCompositeRanges({
      children,
      compositeReplacementActiveRange: SVs._compositeReplacementActiveRange,
      startInd: 0,
      endInd: children.length - 1
    });
  }
  let content = children;
  if (content.length === 0) {
    content = SVs.text;
  }
  if (SVs.inHeader) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("th", { id, ...properties, children: content });
  } else {
    return /* @__PURE__ */ jsxRuntimeExports.jsx("td", { id, ...properties, children: content });
  }
});
export {
  cell as default
};
